import { Paper, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { DocumentCategory } from "../models/documentCategory"

interface Props {
  item: DocumentCategory
}

export default function DocumentCategoryDetailContent({ item }: Props) {
  const { t } = useTranslation()

  return (
    <Stack p="md">
      <Paper withBorder p="sm" radius="md">
        <Text size="xs" tt="uppercase" c="dimmed">{t("documentCategories.name")}</Text>
        <Text>{item.hierarchy_name || item.name}</Text>
      </Paper>
    </Stack>
  )
}
